/// <reference types="node" />

const OP_ENV = window.REACT_APP_OP_ENV || 'development';

type EnvType = {
  PORT: number;
  BACKEND_API: string;
  CLIENT_DNS: string;
  CROP_PATH: string;
  FOREST_PATH: string;
  SEA_PATH: string;
  IMAGE_PATH: string;
  PLATFARM_PATH: string;
  AUTH_PATH: string;
  MAIN_PATH: string;
  CAR_PATH: string;
  COOKIE_DOMAIN: string;
  COOKIE_NAME: string;
  COOKIE_PATH: string;
  SSO_URL: string;
  DEPARTMENT?: string;
  PERSON_NAME?: string;
  PHONE_NUMBER?: string;
};

const env = (): EnvType => {
  if (OP_ENV === 'local') {
    const env = {
      PORT: Number.parseInt(window.REACT_APP_BACKEND_PORT as string) || 8085,
      BACKEND_API: window.REACT_APP_BACKEND_API || 'http://localhost',
      CLIENT_DNS: window.REACT_APP_FRONT_DNS || 'http://localhost',
      CROP_PATH: window.REACT_APP_FRONT_CROP_PATH || 'http://localhost:5004',
      FOREST_PATH: window.REACT_APP_FRONT_FOREST_PATH || 'http://localhost:5005',
      SEA_PATH: window.REACT_APP_FRONT_SEA_PATH || 'http://localhost:5006',
      CAR_PATH: window.REACT_APP_FRONT_CAR_PATH || 'http://localhost:5003',
      IMAGE_PATH: window.REACT_APP_FRONT_IMAGE_PATH || 'http://inp.iptime.org:8081',
      PLATFARM_PATH: window.REACT_APP_FRONT_PFM_PATH || 'http://inp.iptime.org:8080',
      AUTH_PATH: window.REACT_APP_AUTH_PATH || 'https://auth.innopam.kr/',
      MAIN_PATH: window.REACT_APP_MAIN_PATH || 'http://inp.iptime.org:8290',
      COOKIE_DOMAIN: window.REACT_APP_COOKIE_DOMAIN || '.inp.iptime.org',
      COOKIE_NAME: window.REACT_APP_COOKIE_NAME || '_jeju_nia_sso',
      COOKIE_PATH: window.REACT_APP_COOKIE_PATH || '/',
      DEPARTMENT: window.REACT_APP_DEPARTMENT || '우주모빌리티과',
      PERSON_NAME: window.REACT_APP_PERSON_NAME || '김하민주무관',
      PHONE_NUMBER: window.REACT_APP_PHONE_NUMBER || '064-710-4826',
      SSO_URL: window.REACT_APP_SSO_URL || 'http://inp.iptime.org:8083',
    };

    return env;
  } else if (OP_ENV === 'production') {
    const env = {
      PORT: Number.parseInt(window.REACT_APP_BACKEND_PORT as string) || 8085,
      BACKEND_API: window.REACT_APP_BACKEND_API || 'http://inp.iptime.org',
      CLIENT_DNS: window.REACT_APP_FRONT_DNS || 'http://inp.iptime.org',
      CROP_PATH: window.REACT_APP_FRONT_CROP_PATH || 'http://localhost:5004',
      FOREST_PATH: window.REACT_APP_FRONT_FOREST_PATH || 'http://localhost:5005',
      SEA_PATH: window.REACT_APP_FRONT_SEA_PATH || 'http://localhost:5006',
      CAR_PATH: window.REACT_APP_FRONT_CAR_PATH || 'http://localhost:5003',
      IMAGE_PATH: window.REACT_APP_FRONT_IMAGE_PATH || 'http://inp.iptime.org:8081',
      PLATFARM_PATH: window.REACT_APP_FRONT_PFM_PATH || 'http://inp.iptime.org:8080',
      AUTH_PATH: window.REACT_APP_AUTH_PATH || 'https://auth.innopam.kr/',
      MAIN_PATH: window.REACT_APP_MAIN_PATH || 'http://inp.iptime.org:8290',
      COOKIE_DOMAIN: window.REACT_APP_COOKIE_DOMAIN || '.inp.iptime.org',
      COOKIE_NAME: window.REACT_APP_COOKIE_NAME || '_jeju_nia_sso',
      COOKIE_PATH: window.REACT_APP_COOKIE_PATH || '/',
      SSO_URL: window.REACT_APP_SSO_URL || 'http://113.0.1.133:8283',
      DEPARTMENT: window.REACT_APP_DEPARTMENT || '우주모빌리티과',
      PERSON_NAME: window.REACT_APP_PERSON_NAME || '김하민주무관',
      PHONE_NUMBER: window.REACT_APP_PHONE_NUMBER || '064-710-4826',
    };

    return env;
  } else if (OP_ENV === 'development') {
    const env = {
      PORT: Number.parseInt(window.REACT_APP_BACKEND_PORT as string) || 8085,
      BACKEND_API: window.REACT_APP_BACKEND_API || 'http://192.168.0.220:8085',
      CLIENT_DNS: window.REACT_APP_FRONT_DNS || 'http://192.168.0.220',
      CROP_PATH: window.REACT_APP_FRONT_CROP_PATH || 'http://localhost:5004',
      CAR_PATH: window.REACT_APP_FRONT_CAR_PATH || 'http://localhost:5003',
      FOREST_PATH: window.REACT_APP_FRONT_FOREST_PATH || 'http://localhost:5005',
      SEA_PATH: window.REACT_APP_FRONT_SEA_PATH || 'http://localhost:5006',
      IMAGE_PATH: window.REACT_APP_FRONT_IMAGE_PATH || 'http://inp.iptime.org:8081',
      PLATFARM_PATH: window.REACT_APP_FRONT_PFM_PATH || 'http://inp.iptime.org:8080',
      AUTH_PATH: window.REACT_APP_AUTH_PATH || 'https://auth.jga.innopam.kr/',
      MAIN_PATH: window.REACT_APP_MAIN_PATH || 'http://inp.iptime.org:8290',
      COOKIE_DOMAIN: window.REACT_APP_COOKIE_DOMAIN || '.inp.iptime.org',
      COOKIE_NAME: window.REACT_APP_COOKIE_NAME || '_jeju_nia_sso',
      COOKIE_PATH: window.REACT_APP_COOKIE_PATH || '/',
      SSO_URL: window.REACT_APP_SSO_URL || 'http://113.0.1.133:8283',
      DEPARTMENT: window.REACT_APP_DEPARTMENT || '우주모빌리티과',
      PERSON_NAME: window.REACT_APP_PERSON_NAME || '김하민주무관',
      PHONE_NUMBER: window.REACT_APP_PHONE_NUMBER || '064-710-4826',
    };

    return env;
  }
};

export default env;
